import firebase from '../../../firebase'
import { getConversationsContactInfo } from './contact-info'
import { getUsersAndOther } from './utils'

import { initSignIn } from '../../Login/actions/init-signIn'

var db = firebase.firestore();

export const getConversationWithToken = (userId, chatToken, next) => {

  return db.collection("conversations")

    .where(`token-${chatToken}`, '==', true).get()

    .then(({docs: [conversation]}) => {

      var conversationData = conversation.data();

      conversationData.id = conversation.id

      return conversationData

    })

    .then(conversationData => {

      return addUserToConversavtion({
        chatToken,
        userId,
        conversationData
      })

        .then(update => {

          return conversationData

        })

    })

}

export const addUserToConversavtion = ({chatToken, userId, conversationData}) => {

  return db.collection("conversations").doc(conversationData.id)

    .update({
      [`token-${chatToken}`]: firebase.firestore.FieldValue.delete(),
      waitingContactInfo: firebase.firestore.FieldValue.delete(),
      waitingUserId: firebase.firestore.FieldValue.delete(),

      [`user-${userId}`]: true,
    })

}

const getConversations = async(userId, next) => {

  var {docs} = await db.collection("conversations")

    .where(`user-${userId}`, '==', true).get()

  var conversations = docs

    .map(doc => {
      return {

        id: doc.id,
        ...doc.data(),
        ...getUsersAndOther(userId, doc.data()),
      }
    })

  var {docs} = await db.collection("conversations")

    .where(`waitingUserId`, '==', userId).get()

  var requestedConversations = docs

    .map(doc => {
      return {

        id: doc.id,
        ...doc.data(),
        ...getUsersAndOther(userId, doc.data()),
      }
    })

  getConversationsContactInfo([...conversations, ...requestedConversations], next)

  return next({
    type: "userConversationsResponse",
    conversations: [...conversations, ...requestedConversations]
  })


}

export const getUserConversations = (userId, next, chatToken) => {

  if (chatToken && chatToken.length) {

    return getConversationWithToken(userId, chatToken, next)

      .then(conversationData => {

        return getConversations(userId, next)

      })

  } else {

    return getConversations(userId, next)

  }

}


export const getConversation = (conversationUid, next) => {

  return initConversation(next, conversationUid)

}

const initConversation = (next, conversationUid) => {

  var conversationRef = db.collection("conversations").doc(conversationUid);

  return conversationRef

    .get()

    .then((response) => {

      var {docs} = response;

      var doc = response;

      var conversation = doc.data();

      conversation.id = doc.id;

      return next({
        type: "initConversationResponse",
        conversation: {
          ...conversation,
          messages: conversation.messages.reverse()
        }
      })

    })

    .catch(function(error) {

      return next({
        type: "getConversationError",
        error
      })

    });

}


























// WEBPACK FOOTER //
// ./src/Components/Conversations/middleware/conversation-fire.js